import type { Tileset, TilesetVersion, TilesetDataset } from "../types/tileset";
import { Badge, Title } from "@mantine/core";
import { memo, type FC } from "react";

interface TilesetItemTitleProps {
  tileset: Tileset;
  dataset: TilesetDataset | null;
  version: TilesetVersion | null;
}

export const TilesetItemTitle: FC<TilesetItemTitleProps> = memo(({ tileset, dataset, version }) => {
  const { displayName: tilesetDisplayName } = tileset;

  return (
    <>
      <Title size="20px" fw="600">
        {dataset ? `${dataset.key} - ${tilesetDisplayName}` : tilesetDisplayName}
        {version && (
          <Badge size="sm" variant="light">
            {version.format.toUpperCase()}
          </Badge>
        )}
      </Title>

    </>
  );
});
